'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PATH = exports.PATH = {
  VECTOR: 0,
  BEZIER_CURVE: 1,
  CIRCLE: 2
};